import { call, put, takeLatest } from 'redux-saga/effects'
import { USER_VERIFY_REQUEST } from './constants';
import { verifyUserSuccess, verifyUserFailure } from "./actions";
import remote from '../../../../services/remote';
import SentryManager from "../../../../monitoring/Sentry";

function* verifyUser (action) {
    try {
        const response = yield call(remote, {
            route: '/entrance/verify/',
            method: 'post',
            body: JSON.stringify(action.data)
        });
        if (response.success) {
            yield put(verifyUserSuccess(response.data));
        } else {
            yield put(verifyUserFailure(response));
        }
    } catch (e) {
        console.log(e);
        SentryManager.captureException(e);
    }
}

export default function* watchVerifyUserSaga() {
    yield takeLatest(USER_VERIFY_REQUEST , verifyUser);
}



// WEBPACK FOOTER //
// ./src/containers/Layouts/Default/VerifyUser/saga.js